var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-facade',{class:'text size-s',attrs:{"mask":'##/##/####',"placeholder":'mm/dd/yyyy',"id":'field-' + _vm.options.id,"name":'fields[' + _vm.options.id + ']',"masked":true},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }